export enum SceneElementType {
  ArchedShedDoor = 'arched-shed-door',
  BlockComponent = 'block-component',
  CadDoubleDoor = 'cad-double-door',
  CadEmblem = 'cad-emblem',
  CadInsertDoubleDoor = 'cad-insert-double-door',
  CadInsertGarageDoor = 'cad-insert-garage-door',
  CadInsertSingleDoor = 'cad-insert-single-door',
  CadSingleDoor = 'cad-single-door',
  CadVent = 'cad-vent',
  CadWindow = 'cad-window',
  CadWindowSemicircle = 'cad-window-semicircle',
  DakotaShelves = 'dakota-shelves',
  DiamondWindow = 'diamond',
  DoubleEntryDoor = 'double-entry-door',
  DoubleEntryDoorWithFifteenLiteWindow = 'double-entry-door-fifteen-lite',
  DoubleEntryDoorWithFourLiteWindow = 'double-entry-door-four-lite',
  DoubleEntryDoorWithFullLiteWindow = 'double-entry-door-full-lite',
  DoubleEntryDoorWithHalfLiteWindow = 'double-entry-door-half-lite',
  DoubleEntryDoorWithNineLiteWindow = 'double-entry-door-nine-lite',
  DoubleEntryDoorWithRadiusWindow = 'double-entry-door-radius-window',
  DoublePrehungEntryDoor = 'double-prehung-entry-door',
  DoublePrehungEntryDoorWithFifteenLiteWindow = 'double-prehung-entry-door-fifteen-lite',
  DoublePrehungEntryDoorWithFourLiteWindow = 'double-prehung-entry-door-four-lite',
  DoublePrehungEntryDoorWithFullLiteWindow = 'double-prehung-entry-door-full-lite',
  DoublePrehungEntryDoorWithHalfLiteWindow = 'double-prehung-entry-door-half-lite',
  DoublePrehungEntryDoorWithNineLiteWindow = 'double-prehung-entry-door-nine-lite',
  DoublePrehungEntryDoorWithRadiusWindow = 'double-prehung-entry-door-radius-window',
  DoubleShedDoor = 'double-shed-door',
  DoubleShedDoorLeftDoorHalfSize = 'double-shed-door-left-door-half-size', // duratuf hack
  DoubleSlidingShedDoor = 'double-sliding-shed-door',
  DoubleUberDoor = 'double-uber-door',
  EntryDoor = 'entry-door',
  EntryDoorWithFifteenLiteWindow = 'entry-door-fifteen-lite',
  EntryDoorWithFourLiteWindow = 'entry-door-four-lite',
  EntryDoorWithFullLiteWindow = 'entry-door-full-lite',
  EntryDoorWithHalfLiteWindow = 'entry-door-half-lite',
  EntryDoorWithNineLiteWindow = 'entry-door-nine-lite',
  EntryDoorWithRadiusWindow = 'entry-door-radius-window',
  FauxWindow = 'faux-window',
  FixedWindow = 'fixed-window',
  Frameout = 'frameout',
  FreeformShelf = 'freeform-shelf',
  GableDormer = 'gable-dormer',
  GarageDoor = 'garage-door',
  GarageDoorWithWindows = 'garage-door-with-windows',
  GeneratedWorkbench = 'generated-workbench',
  NestingBox = 'nesting-box',
  OctagonWindow = 'octagon',
  PorchRoof = 'porch-roof',
  PrehungEntryDoor = 'prehung-entry-door',
  PrehungEntryDoorWithFifteenLiteWindow = 'prehung-entry-door-fifteen-lite',
  PrehungEntryDoorWithFourLiteWindow = 'prehung-entry-door-four-lite',
  PrehungEntryDoorWithFullLiteWindow = 'prehung-entry-door-full-lite',
  PrehungEntryDoorWithHalfLiteWindow = 'prehung-entry-door-half-lite',
  PrehungEntryDoorWithNineLiteWindow = 'prehung-entry-door-nine-lite',
  PrehungEntryDoorWithRadiusWindow = 'prehung-entry-door-radius-window',
  RampageDoor = 'rampage-door',
  RollupDoor = 'rollup-door',
  ShedDoor = 'shed-door',
  ShedDormer = 'shed-dormer',
  SingleHungWindow = 'single-hung-window',
  SliderWindow = 'slider',
  SlidingShedDoor = 'sliding-shed-door',
  Transom = 'transom', // TODO: get rid of 'Transom', replace with 'TransomWindow'.
  TransomWindow = 'transom-window',
  TrapezoidWindow = 'trapezoid-window',
  UberDoor = 'uber-door',
  VinylDoubleDoor = 'vinyl-double-door',
  WallAccent = 'wall-accent',
}
